export { Lightbox } from './lightbox.service';
export { LightboxConfig } from './lightbox-config.service';
export { LightboxEvent, LIGHTBOX_EVENT } from './lightbox-event.service';
export { LightboxModule } from './lightbox.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/angular2-lightbox/index.js
// module id = ../../../../angular2-lightbox/index.js
// module chunks = 3